import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'redux';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import isEqual from 'lodash/isEqual';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import reduce from 'lodash/reduce';

import { watchQueryParamsInBuilder } from '../builder/actions';
import { isInBuilder } from '../../lib/helpers';
import { safeStringify } from '../../lib/query-param-helpers';

class QueryParamManager extends React.Component {
  constructor(props) {
    super(props);
    this.updateQueryParams = this.updateQueryParams.bind(this);
  }

  componentDidMount() {
    this.updateQueryParams();
  }

  shouldComponentUpdate(nextProps) {
    return (
      this.props.watchQueryParams !== nextProps.watchQueryParams ||
      !isEqual(this.props.queryParams, nextProps.queryParams)
    );
  }

  componentDidUpdate() {
    this.updateQueryParams();
  }

  updateQueryParams() {
    const { watchQueryParams, dispatch, history, queryParams } = this.props;

    // we want to go from a repeatable of [{ name: <param name 1>, value: <param value 1> }, { name: <param name 2>, value: <param value 2> }]
    // to an object of { <param name 1>: <param value 1>, <param name 2>: <param value 2> }
    const processedQueryParams = reduce(
      queryParams,
      (paramObject, newParam) => ({
        ...paramObject,
        [newParam.name]: newParam.value,
      }),
      {}
    );

    const url = get(history, 'location.pathname');
    // only replace query params if we're in the builder and they're different than the existing query params
    if (
      isInBuilder(url) &&
      !isEqual(
        get(history, 'location.search'),
        safeStringify(processedQueryParams)
      )
    ) {
      history.replace({
        pathname: url,
        search: safeStringify(processedQueryParams),
      });
    }

    dispatch(watchQueryParamsInBuilder(watchQueryParams));
  }

  render() {
    return null;
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
QueryParamManager.propTypes = {
  watchQueryParams: PropTypes.bool,
  dispatch: PropTypes.func,
  history: PropTypes.object,
  queryParams: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
    })
  ),
};

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
QueryParamManager.defaultProps = {
  queryParams: [],
  watchQueryParams: false,
};

export default compose(withRouter, connect())(QueryParamManager);
